// React Core
import { useEffect, useState } from "react";

// Redux Toolkit
import { useSelector } from "react-redux";
import { AppState } from "./store/store";

// Aura Camera Components
import AuraCameraOperations from "./components/AuraCamera/operations/operations";
import AuraCameraOperationsDetails from "./components/AuraCamera/operation-details/index";
import AuraSites from "./components/AuraCamera/sites/sites";
import AuraSitesCreation from "./components/AuraCamera/sites/sites-creation";
import AuraRouteSummary from "./components/AuraCamera/routes/route_summary/index";
import AuraRouteDetails from "./components/AuraCamera/routes/route_details/index";
import CameraOperators from "./components/AuraCamera/camera-operator/index";
import AddEditCamerOperator from "./components/AuraCamera/camera-operator/components/camera-operator-creation"

// Nifty Components
import { Header } from "./components/common/header";
import { Footer } from "./components/common/footer";
import MainNav from "./components/common/main-navigator/main-nav";
import "./assets/css/navy.css";

// React Router Dom
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// Services
import { isAuth } from "./services/AuraCamera/common";

// Prime React
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

// Broken URL Component
import BrokenUrl from "./components/common/BrokenUrl";

// Access Mode
import { PermissionsProvider } from "./providers/PermissionsProvider";

// Idle Time calculations
import { useIdleTimer } from "react-idle-timer";

const idleTimeInMinutes: number = parseInt(
  process.env.REACT_APP_IDLE_TIME_IN_MINUTES ?? "10"
);
const mainSiteUrl = process.env.REACT_APP_MVC_URL;

function App(): JSX.Element {
  // Check for isAuth (isAuth true after login)
  let authStatus = useSelector(
    (state: AppState) => state.AuraCameraCommon.isAuth
  );
  isAuth(authStatus);

  const onIdle = () => {
    localStorage.clear();
    if (mainSiteUrl) window.location.assign(mainSiteUrl);
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/nifty.min.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    timeout: 1000 * 60 * idleTimeInMinutes,
    throttle: 500,
  });

  return (
    <>
      <Router>
        <PermissionsProvider>
          <section id="content" className="content">
            <Routes>
              <Route path="/" element={<AuraCameraOperations />} />

              {/* Broken URL Route */}
              <Route path="/aogi/broken_url" element={<BrokenUrl />} />

              {/* Aura Camera Routes */}
              <Route
                path="/aura-camera/operations"
                element={<AuraCameraOperations />}
              />
              <Route
                path="/aura-camera/operation-details/:siteID/:surveyDate_url"
                element={<AuraCameraOperationsDetails />}
              />
              <Route path="/aura-camera/sites" element={<AuraSites />} />
              <Route
                path="/aura-camera/sites-creation"
                element={<AuraSitesCreation />}
              />
              <Route
                path="/aura-camera/sites-creation/:id"
                element={<AuraSitesCreation />}
              />
              <Route
                path="/aura-camera/camera-operator-creation"
                element={<AddEditCamerOperator />}
              />
              <Route
                path="/aura-camera/camera-operator-creation/:id"
                element={<AddEditCamerOperator />}
              />
              <Route
                path="/aura-camera/route-summary"
                element={<AuraRouteSummary />}
              />

              <Route
                path="/aura-camera/camera-operators"
                element={<CameraOperators />}
              />

              <Route
                path="/aura-camera/route-details/:siteID"
                element={<AuraRouteDetails />}
              />
            </Routes>
            <Footer />
          </section>
          <Header />
          <MainNav />
          {/* <SideBar /> */}
          <div className="scroll-container">
            <a
              href="#root"
              className="scroll-page rounded-circle ratio ratio-1x1"
            ></a>
          </div>
        </PermissionsProvider>
      </Router>
    </>
  );
}
export default App;
